import { ShowcaseOrientation } from '@space-shell/common/services/membership'
import styled from 'styled-components'

export const CardWrapper = styled.div<{ $orientation?: ShowcaseOrientation }>`
  display: block;
  outline: none;
  aspect-ratio: ${({ $orientation }) =>
    $orientation === ShowcaseOrientation.HORIZONTAL ? '16/9' : '9/13'};
`

CardWrapper.displayName = 'CardWrapper'
